<template>
    <div class="d-ins">
        <p><strong>Compare your answers with the real answer, and those provided by other participants.</strong></p>
        <div class="row">
          <div class="col-xl-12">
            <div class="cht-problem1">
              <strong>Problem 1</strong>
            </div>
            <div class="cht-problem2">
              <strong>Problem 2</strong>
            </div>
          </div>
          <div class="col-1">
            <div class="text-wrap cht-title">
              Blue cab estimated <br>probability (%)
            </div>
          </div>
          <div class="col-11">
            <div class="cht-score s1">{{ Math.round(option.series[0].data[0]) }}%</div>
            <div class="cht-score s2">{{ Math.round(option.series[0].data[1]) }}%</div>
            <div class="cht-avg"><div class="cht-score s3">{{ Math.round(option.series[0].data[2]) }}%</div></div>
            <div class="cht-score s4">{{ Math.round(option.series[0].data[3]) }}%</div>
            <div class="cht-score s5">{{ Math.round(option.series[0].data[4]) }}%</div>
            <v-chart :options="option" v-if="ready == true"/>
          </div>
          <div class="col-12">
            <div class="text-wrap cht-title-x text-center">
              Answers
            </div>
          </div>
        </div>
        <br>
        <p>To see how the problem is calculated using Bayes’ theorem, and to understand how the answer of {{ Math.round(option.series[0].data[2]) }}% has been calculated, read about Koehler and the ‘base-rate fallacy’,</p>
        <p class="text-center">Data from Tversky and Kahneman (1982)</p>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    // 'v-chart': ECharts
  },
  data () {
    return {
      ready: false,
      option: {
        xAxis: {
          axisTick: { show: false },
          type: 'category',
          data: ['Participants', 'Your\nanswer', 'Actual\nprobability\n(the same for\nboth problems)', 'Participants', 'Your\nanswer']
        },
        yAxis: {
          splitLine: {
            show: false
          },
          type: 'value',
          max: 100,
          min: 0,
          interval: 10
        },
        series: [{
          itemStyle: {
            normal: {
              color: 'gray'
            },
            emphasis: {
              color: 'gray'
            }
          },
          data: [80, 12, 41, 60, 12],
          type: 'bar'
        }]
      }
    }
  },
  created () {
    this.option.series[0].data[0] = this.raw.problem1.length == 0 ? 0 : this.raw.problem1.reduce((a, b) => a + b, 0) / this.raw.problem1.length
    this.option.series[0].data[1] = this.problem1
    this.option.series[0].data[2] = this.raw.problem1.length == 0 ? 0 : this.raw.all.reduce((a, b) => a + b, 0) / this.raw.all.length
    this.option.series[0].data[3] = this.raw.problem1.length == 0 ? 0 : this.raw.problem2.reduce((a, b) => a + b, 0) / this.raw.problem2.length
    this.option.series[0].data[4] = this.problem2
    this.ready = true
  },
  mounted () {
  },
  computed: {
    ...mapGetters([
      'getData'
    ]),
    problem1 () {
      return this.getData('problem1')
    },
    problem2 () {
      return this.getData('problem2')
    },
    raw () {
      return this.getData('raw')
    },
  }
}
</script>
